

export class ViajeDetalle {

public  idCompania: string;
public  idUsuario: string;
public nombreUsuario: string;
public  idViaje: string;
public  idVisita: string;
public  idPunto: string;
public  nombrePunto: string;
public  fechaInicio: Date;
public  fechaFinalizacion: Date;

public  abortados: number;
public  realizados: number;
public  pendientes: number;
public  totalTareas: number;
public  estadoVisita: string;

public  motivo: string;
public idVehiculo:string;
}